import React, {useState} from 'react'
import {Dialog, DialogActions, DialogContent, Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import PowerIcon from '@material-ui/icons/PowerSettingsNew'
import Tr from 'translations/Translations';
import Button from 'components/Button';
import {connect} from 'react-redux'
import Title from 'components/Title';
import useInterval from 'hooks/useInterval';
import moment from 'moment';
import UserService from 'services/UserService';
import OAuthService from 'services/OAuthService';
import reduxStore from 'redux/store'

const style = theme => ({
	root: {
	},
	icon: {
		fontSize: theme.components.icon.fontSize,
	},
	content: {
		textAlign: 'center',
		'&>*': {
			marginTop: theme.spacing(2),
		}
	},
	title: {
	}
})

function Session({
	classes
}) {
	const [open, setOpen] = useState(false)
	const time = open ? 1000 : 30000;

	const [timeLeft, setTimeLeft] = useState('0:00')

	useInterval(() => {
		const state = reduxStore.getState();
		const sessionTime = state.resources.sessionTime;
		if (!sessionTime) return;
		const { endTime } = sessionTime;
		if (!open) {
			const diff = endTime.diff(moment(), 's')
			if (diff <= 305) {
				setOpen(true)
			}
		} else {
			const diff = endTime.diff(moment());
			setTimeLeft(diff > 0 ? moment.utc(diff).format('m:ss') : '0:00');
			if (diff <= 0) {
				setTimeout(() => OAuthService.logout(), 1000);
			}
		}
	}, time)

	const handleContinue = () => {
		UserService.sessionTime()
			.then(() => {
				setOpen(false)
			})
	}


	return (
		<Dialog
			open={open}
			className={classes.root}
		>
			<DialogContent className={classes.content}>
				<PowerIcon color='primary' className={classes.icon} />
				<Title className={classes.title}>
					{Tr('session_title')}
				</Title>
				<Typography variant='h4' color='primary'>
					{timeLeft}
				</Typography>
				<Typography variant='body1'>
					{Tr('session_d_2')}
				</Typography>
				<Button onClick={handleContinue}>
					{Tr('continue_working')}
				</Button>
			</DialogContent>
			<DialogActions />
		</Dialog>
	)
}

Session.propTypes = {
	classes: PropTypes.any,
}

Session.defaultProps = {
}

export default connect((state) => ({
}), {
})(withStyles(style)(Session));